import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import Field from "../../../components/Fields/Field";
import FieldLabel from "../../../components/Fields/FieldLabel";
import NumberControl from "../../../components/Fields/NumberControl";
import NumberField from "../../../components/Fields/NumberField";
import SelectListField from "../../../components/Fields/SelectListField";
import TextboxField from "../../../components/Fields/TextboxField";
import { ControlProps, FieldProps, LabelProps } from "../../../components/Fields/Types";
import useSelectListOptions from "../../../components/Hooks/SelectListOptionsHook/useSelectListOptions";
import MilestoneDefinitionModel from "../../../models/MilestoneDefinitionModel";

export interface Props {
    getFieldProps: (fieldName: string) => FieldProps
    getControlProps: (fieldName: string) => ControlProps
    getLabelProps: (fieldName: string) => LabelProps
    formData: MilestoneDefinitionModel
}

const MilestoneDefinitionControl: React.FC<Props> = ({ getFieldProps, getControlProps, getLabelProps, formData }) => {
    const projectTypes = useSelectListOptions('api/v1/selectlist/ProjectTypes', '-- Select project type');
    const milestoneTypes = useSelectListOptions('api/v1/selectlist/MilestoneTypes', '-- Select milestone type');
    const attachmentTypes = useSelectListOptions('api/v1/selectlist/AttachmentTypes', '-- Select attachment type');

    return (
        <Container fluid>
            <Row>
                <Col md='12'>
                    <SelectListField {...getFieldProps('projectTypeId')} options={projectTypes} />
                    <TextboxField {...getFieldProps('name')} />
                    <SelectListField {...getFieldProps('milestoneTypeId')} options={milestoneTypes} />
                    <SelectListField {...getFieldProps('attachmentTypeId')} options={attachmentTypes} />
                    <NumberField {...getFieldProps('daysToAchieve')} />
                    <Field text='Late after' labelSize={3} required={false}>
                        <NumberControl {...getControlProps('lateDays')} width={100} />
                        <span style={{ padding: '7px 15px' }}><FieldLabel {...getLabelProps('lateDays')} /></span>
                        <NumberControl {...getControlProps('lateHours')} width={100} />
                        <span style={{ padding: '7px 15px' }}><FieldLabel {...getLabelProps('lateHours')} /></span>
                        <NumberControl {...getControlProps('lateMinutes')} width={100} />
                        <span style={{ padding: '7px 15px' }}><FieldLabel {...getLabelProps('lateMinutes')} /></span>
                    </Field>
                    <Field text='Missed after' labelSize={3} required={false}>
                        <NumberControl {...getControlProps('missedDays')} width={100} />
                        <span style={{ padding: '7px 15px' }}><FieldLabel {...getLabelProps('missedDays')} /></span>
                        <NumberControl {...getControlProps('missedHours')} width={100} />
                        <span style={{ padding: '7px 15px' }}><FieldLabel {...getLabelProps('missedHours')} /></span>
                        <NumberControl {...getControlProps('missedMinutes')} width={100} />
                        <span style={{ padding: '7px 15px' }}><FieldLabel {...getLabelProps('missedMinutes')} /></span>
                    </Field>
                </Col>
            </Row>
        </Container>    )
}
export default MilestoneDefinitionControl;